import type { IconData } from '@stacksjs/iconify-core'

export const intellectualSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.5 20.333C2.5 9.927 11.025 1.5 21.53 1.5c10.373 0 18.815 8.218 19.025 18.444l3.88 5.41c.693.966.62 2.38-.505 3.069c-.853.52-2.099 1.127-3.771 1.57l-.576 6.83a3.5 3.5 0 0 1-3.917 3.18l-2.52-.312v2.917c0 1.507-.981 2.87-2.519 3.155c-1.851.345-4.884.737-9.098.737s-7.246-.392-9.098-.737c-1.537-.286-2.52-1.648-2.52-3.155V35.25C5.407 31.808 2.5 26.407 2.5 20.333m7.14 3.333c-1.492-5.236.692-11.012 5.62-13.858c4.93-2.846 11.024-1.85 14.813 2.061c1.152 1.19.638 3.062-.797 3.89l-15.868 9.162c-1.435.828-3.313.338-3.767-1.255\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default intellectualSolid
